/*******
Common Function Used In Diamond Listing & Detail Page 
********/

/*** Pre Define Constant Values For Webservice Call ***/
const api = "https://py.bluehira.com/live/graphql/";
const naturalDiamondListingApi = "diamondData";
const labDiamondListingApi = "diamondData";
const naturalDiamondDetailApi = "diamondById";
const labDiamondDetailApi = "diamondById";
const diamondSearchByReportApi = "diamondByStockorcert";
const naturalDiamondAddToCart = "diamondAddToCart";
const labDiamondAddToCart = "diamondAddToCart";
const productMetafield = "variantMetafield";
const naturalRingAddToCart = "ringAddToCart";
const labRingAddToCart = "ringAddToCart";
const shopUrl = "https://bluehira.com/";
//const shopUrl = "https://www.bluehira.com/";
// const shopUrl = "https://j1pvvd-1s.myshopify.com/";
// console.log("shopUrl",shopUrl)
const collectionHandel = "engagement-ring-settings";
// console.log(collectionHandel);
const diamondCollectionHandel = "diamonds";
/*** End ***/

/*** Store Language Code ***/
const store_lang = window.Shopify.locale;
/*** End ***/

/*** Get Query Parameter Array from URL ***/
function getQueryMap(query) {
    if(typeof query !== 'string') {
       return null;
    }
    
    var toType = function(a) {
      return ({}).toString.call(a).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }, map = {};
    
  // map the hit query into a proper object
  query.replace(/([^&|\?=]+)=?([^&]*)(?:&+|$)/g, function (match, key, value) {
      if (key in map) {
          // the key already exists, so we need to check if it is an array, if not, make it an array and add the new value
          if (toType(map[key]) !== 'array') {
              // it's not an array - make it an array
              map[key] = [map[key]];
          }
          // push the new value into the array
          map[key].push(value);
      } else {
          // put the value into the map
          map[key] = value;
      }
  });
  return map;
}
/*** End ***/

/*** AddCommas in price start ***/
function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}
/*** addCommas in price end ***/

/*** Get Certificate File URL Start ***/
function getCertificateUrl(diamondData) {
  var certificateFile = '';
  var diaLab = diamondData.lab;
  var diaCertNo = diamondData.certificateNumber;
  var diaCarat = diamondData.caratWeight;
  
  if(diamondData.certificateFile != ''){
    certificateFile = diamondData.certificateFile;
  }else{
    switch(diaLab)
      {
        case "GIA":
            certificateFile = 'https://www.gia.edu/cs/Satellite?reportno='+diaCertNo+'&childpagename=GIA%2FPage%2FReportCheck&pagename=GIA%2FDispatcher&c=Page&cid=1355954554547#main-content';
            break;
        case "IGI":
            certificateFile = 'https://www.igi.org/verify-your-report/?r='+diaCertNo;
            break;
        case "HRD":
            certificateFile = 'https://my.hrdantwerp.com/?record_number='+diaCertNo+'&weight='+diaCarat;
            break;
        case "AGS":
            certificateFile = 'https://www.agslab.com/reportTypes/pdqr.php?StoneID='+diaCertNo+'&Weight='+diaCarat+'&D=1';
            break;
        default:
            certificateFile = "";
      }
  }    
  return certificateFile;
}
/*** End ***/

/*** Diamond Broken Image Fixes start ***/ 
function imgError(image,defaultImage) {
  image.onerror = "";
  image.src = defaultImage;
  return true;
}
/*** End ***/  

/*** Get Diamond Default Final Price Field Start ***/
function getDiamondDefaultFinalPriceField(currencyCode){
  var diamond_price_field;
	switch (currencyCode) {		
		case "EUR":
			diamond_price_field = "finalPriceEur";
			break;
		case "GBP":
			diamond_price_field = "finalPriceGbp";
			break;
		case "USD":
			diamond_price_field = "finalPriceUsd";
			break;		
		default:
			diamond_price_field = "finalPriceGbp"
	}
	return diamond_price_field;
}
function getDiamondDefaultComparFinalPriceField(currencyCode){
  var diamond_price_field;
	switch (currencyCode) {		
		case "EUR":
			diamond_price_field = "markupPriceEur";
			break;
		case "GBP":
			diamond_price_field = "markupPriceGbp";
			break;
		case "USD":
			diamond_price_field = "markupPriceUsd";
			break;		
		default:
			diamond_price_field = "markupPriceUsd"
	}
	return diamond_price_field;
}
/*** End ***/  

/*** Get Diamond Price Start ***/
function getDiamondPrice(currencyRate,finalPrice) {  
 
  var final_dia_price = finalPrice * currencyRate; 
  var dia_formatted_price = Math.ceil(final_dia_price);      
  dia_formatted_price = Shopify.formatMoney(dia_formatted_price * 100, theme.moneyFormat);
  dia_formatted_price = dia_formatted_price.replace(/([.,])00$/, '');
  return dia_formatted_price;
}
/*** End ***/

/*** Get Diamond Type Start ***/
function getDiamondType(diamondType) {
  var type = diamondType;
  if(type == 'natural-white' || type == 'natural-fancy'){
    dia_type = translations.titleNatural;
  }else{
    dia_type = translations.titleLabGrown;
  }
  return dia_type;
}
/*** End ***/

/*** Get Diamond Name Start ***/
function getDiamondName(diamondData,diamondType) {
  var diamond_name = diamondData.caratWeight + "-Carat " + diamondData.shape + " Shape "+ diamondType +" Diamond ";
  return diamond_name;
}
/*** End ***/

/*** Get Diamond measurement Start ***/
function getDiamondMeasurement(diamondData) {
  if(diamondData.measurement != ''){
    var measurements = diamondData.measurement;
  }else{
    var measurements = diamondData.length + " * " + diamondData.width + " * " + diamondData.depth;
  }  
  return measurements;
}
/*** End ***/

/*** Get Diamond Girdle Start ***/
function getDiamondGirdle(diamondData) {
  if(diamondData.girdleMin != '' && diamondData.girdleMax != ''){
    var girdle = diamondData.girdleMin+"-"+diamondData.girdleMax;
  }else if(diamondData.girdleMax == ''){
    var girdle = diamondData.girdleMin;
  }else if(diamondData.girdleMin == ''){
    var girdle = diamondData.girdleMax;
  }else{
    var girdle = 'NA';
  }  
}
/*** End ***/

/*** Get Diamond Detail Information ***/
function getDiamondDetailInfo(diamondData) {  
  var diamondInformation = getDiamondInformationLayout(diamondData);
  
  var detailInfo = '';  
  detailInfo += '<div class="tps-product-details">';
  detailInfo += '<div class="tps-product-detail-section-heading" data-section="diamond-info"><h2>'+translations.titleDiamondDetails+'</h2><span class="tps-tab-arrow tps-arrow-down"></span></div>';
  detailInfo += '<div class="tps-product-details-info tps-product-details-diamond-info" style="display:none;">';   
  detailInfo += diamondInformation;
  detailInfo += '</div>';
  detailInfo += '</div>';
  return detailInfo;
}
/*** End ***/

/*** Get Diamond Detail Information Layout ***/
function getDiamondInformationLayout(diamondData) {
  var diamond_certificate_url = getCertificateUrl(diamondData);
  var diamond_measurements = getDiamondMeasurement(diamondData);

  var diamond_ratio = diamondData.ratio;
   if(diamond_ratio == '0.0'){
     // var dia_ratio = '-';
     dia_ratio = diamondData.length/diamondData.width;
     dia_ratio = dia_ratio.toFixed(2);
   }else{
     dia_ratio = diamond_ratio;
   }

   var diamond_girdle = diamondData.girdle;
    if(diamond_girdle == null || diamond_girdle == undefined){
      // if(diamondData.girdleMin != '' && diamondData.girdleMax != '' && diamondData.girdleMin != 0 && diamondData.girdleMax != 0){
      //   diamond_girdle = diamondData.girdleMin+"-"+diamondData.girdleMax;
      // }else{
      //   diamond_girdle = "-";
      // }   
  
      diamond_girdle = getDiamondGirdle(diamondData);
    }

  var diamond_intensity = diamondData.fancyColorIntensity;
  if(diamond_intensity == null || diamond_intensity == undefined) {
      diamond_intensity = "";
  }

  var diamond_overtone = diamondData.fancyColorOvertone;
  if(diamond_overtone == null || diamond_overtone == undefined) {
      diamond_overtone = "";
  }
  
  //Dynamic Diamond Information Array 
  var diamondInformation = {
    "diamondStockId" : translations.titleStockID+' - '+diamondData.stockNumber,
    "diamondShape"   : translations.titleShape+' - '+diamondData.shape,
    "diamondCarat"   : translations.titleCaratWeight+' - '+diamondData.caratWeight,
    "diamondCut"     : translations.titleCut+' - '+diamondData.cut,
    "diamondColor"   : translations.titleColor+' - '+diamondData.color,
    "diamondFancyColor" : translations.titleColor+' - '+diamondData.fancyColor,
    "diamondClarity" : translations.titleClarity+' - '+diamondData.clarity,
    "diamondReport"  : translations.titleGradingReport+' - '+diamondData.lab+' - '+diamond_certificate_url,
    "diamondFluorescence" : translations.titleFluorescence+' - '+diamondData.flourIntensity,
    "diamondTable"   : translations.titleTable+' - '+diamondData.tablePerc,
    "diamondDepth"   : translations.titleDepth+' - '+diamondData.deptPerc,
    "diamondMeasurement" : translations.titleMeasurement+' - '+diamond_measurements,
    "diamondRatio"   : translations.titleRatio+' - '+dia_ratio,
    "diamondSymmetry": translations.titleSymmetry+' - '+diamondData.symmetry,
    "diamondPolish"  : translations.titlePolish+' - '+diamondData.polish,
    "diamondgirdle"  : translations.titleGirdle+' - '+diamond_girdle,
    "diamondCulet"   : translations.titleCulet+' - '+diamondData.culet,
    "diamondIntensity"  : translations.titleIntensity+' - '+diamond_intensity,
    "diamondOvartone"   : translations.titleOvertone+' - '+diamond_overtone,
  };
  //end

  //Diamond Information HTML Layout
  var detailInfo = '';
  if(diamondInformation != ''){
     var j = 1;
     $.each(diamondInformation, function(i, diamondInfo) {
       var diamondInfoArray = diamondInfo.split(" - ");
       if(diamondInfoArray.length > 1){
         var infoLable = diamondInfoArray[0];
         if(infoLable == 'Girdle'){
           if(diamondInfoArray.length == 3){
             var infoValue = diamondInfoArray[1]+' - '+diamondInfoArray[2];
           }else if(diamondInfoArray.length == 2){
             var infoValue = diamondInfoArray[1];
           }else{
             var infoValue = "-";
           }           
         }else{
           var infoValue = diamondInfoArray[1];
         }
        
         if(diamondInfoArray[1] != ''){
           if(diamondInfoArray.length == 3 && infoLable != 'Girdle'){
             var infoUrl = diamondInfoArray[2];
             detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info"><a href="'+infoUrl+'" target="_blank" alt="Certificate URL" title="Certificate Title">'+infoValue+'</a></span></div> ';
           }else{
             if(infoValue != 'null'){
               detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info">'+infoValue+'</span></div> ';
             }             
           } 
           j++;
         }
       }        
    });
  }
  //end
  
  return detailInfo;
}
function getDiamondDetailInformationLayout(diamondData) {
  var diamond_certificate_url = getCertificateUrl(diamondData);
  var diamond_measurements = getDiamondMeasurement(diamondData);

  var type = diamondData.diamondType;
  if(type == 'lab-white' || type == 'lab-fancy'){
    type = translations.titleLabGrown;
  }

  var diamond_ratio = diamondData.ratio;
   if(diamond_ratio == '0.0'){
     // var dia_ratio = '-';
     dia_ratio = diamondData.length/diamondData.width;
     dia_ratio = dia_ratio.toFixed(2);
   }else{
     dia_ratio = diamond_ratio;
   }

   var diamond_girdle = diamondData.girdle;
    if(diamond_girdle == null || diamond_girdle == undefined){
      // if(diamondData.girdleMin != '' && diamondData.girdleMax != '' && diamondData.girdleMin != 0 && diamondData.girdleMax != 0){
      //   diamond_girdle = diamondData.girdleMin+"-"+diamondData.girdleMax;
      // }else{
      //   diamond_girdle = "-";
      // }   
  
      diamond_girdle = getDiamondGirdle(diamondData);
    }

  var diamond_intensity = diamondData.fancyColorIntensity;
  if(diamond_intensity == null || diamond_intensity == undefined) {
      diamond_intensity = "";
  }

  var diamond_overtone = diamondData.fancyColorOvertone;
  if(diamond_overtone == null || diamond_overtone == undefined) {
      diamond_overtone = "";
  }
  
  //Dynamic Diamond Information Array 
  var diamondInformation = {    
    "diamondType"   : translations.titleDiamondType+' - '+type,
    "diamondShape"   : translations.titleShape+' - '+diamondData.shape,
    "diamondCarat"   : translations.titleCaratWeight+' - '+diamondData.caratWeight,
    "diamondColor"   : translations.titleColor+' - '+diamondData.color,
    "diamondFancyColor" : translations.titleColor+' - '+diamondData.fancyColor,
    "diamondClarity" : translations.titleClarity+' - '+diamondData.clarity,
    "diamondCut"     : translations.titleCut+' - '+diamondData.cut,  
    "diamondReport"  : translations.titleGradingReport+' - '+diamondData.lab+' - '+diamond_certificate_url,
    "diamondFluorescence" : translations.titleFluorescence+' - '+diamondData.flourIntensity,
    "diamondTable"   : translations.titleTable+' - '+diamondData.tablePerc,
    "diamondDepth"   : translations.titleDepth+' - '+diamondData.deptPerc,
    "diamondMeasurement" : translations.titleMeasurement+' - '+diamond_measurements,
    "diamondRatio"   : translations.titleRatio+' - '+dia_ratio,
    "diamondSymmetry": translations.titleSymmetry+' - '+diamondData.symmetry,
    "diamondPolish"  : translations.titlePolish+' - '+diamondData.polish,
    "diamondgirdle"  : translations.titleGirdle+' - '+diamond_girdle,
    "diamondCulet"   : translations.titleCulet+' - '+diamondData.culet,
    "diamondIntensity"  : translations.titleIntensity+' - '+diamond_intensity,
    "diamondOvartone"   : translations.titleOvertone+' - '+diamond_overtone,
  };
  //end

  //Diamond Information HTML Layout
  var detailInfo = '';
  if(diamondInformation != ''){
     var j = 1;
     $.each(diamondInformation, function(i, diamondInfo) {
       var diamondInfoArray = diamondInfo.split(" - ");
       if(diamondInfoArray.length > 1){
         var infoLable = diamondInfoArray[0];
         if(infoLable == 'Girdle'){
           if(diamondInfoArray.length == 3){
             var infoValue = diamondInfoArray[1]+' - '+diamondInfoArray[2];
           }else if(diamondInfoArray.length == 2){
             var infoValue = diamondInfoArray[1];
           }else{
             var infoValue = "-";
           }           
         }else{
           var infoValue = diamondInfoArray[1];
         }
        
         if(diamondInfoArray[1] != ''){
           if(diamondInfoArray.length == 3 && infoLable != 'Girdle'){
             var infoUrl = diamondInfoArray[2];
             detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info"><a href="'+infoUrl+'" target="_blank" alt="Certificate URL" title="Certificate Title">'+infoValue+'</a></span></div> ';
           }else{
             if(infoValue != 'null'){
               detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info">'+infoValue+'</span></div> ';
             }             
           } 
           j++;
         }
       }        
    });
  }
  //end
  
  return detailInfo;
}
/*** End ***/

/*** Config function forpre define module url start ***/
if(store_lang == 'de'){
  var tps_config = {
	"urls": {        
        "lab_diamond": "/pages/labor-weisser-diamant",
        "loose_color_diamond": "/pages/naturlicher-farbiger-diamant",
        "loose_diamond": "/pages/naturlicher-weisser-diamant",
        "loose_diamond_detail": "/pages/diamant-einzelheiten",
	}
  }
}else{
  var tps_config = {
	"urls": {        
        "loose_diamond": "/pages/ringbuilder-natural-white-diamonds",
        "lab_diamond": "/pages/ringbuilder-lab-grown-white-diamonds",
        "loose_color_diamond": "/pages/ringbuilder-natural-color-diamonds", 
        "lab_color_diamond": "/pages/ringbuilder-lab-grown-color-diamonds",
        "loose_diamond_detail": "/pages/ringbuilder-diamond-details",
        "setting_listing": "/collections/engagement-ring-settings",
        "selected_setting_listing": "/collections/engagement-ring-settings",
        "final_ring": "/pages/final-engagement-ring",
	}

  }
}
/*** End ***/

/*** Remove HTML Elements In Mobile ***/
function removeHtmlElementsInMobile() {  
  jQuery('.tps-mobile-hide').remove();	
}
/*** End ***/

/*** Remove HTML Elements In Desktop ***/
function removeHtmlElementsInDesktop() {
  jQuery('.tps-desktop-hide').remove();	
}
/*** End ***/

/*** Get Closest Number From Array ***/
function getClosestNum(num, ar) {
	var i = 0,
		closest, closestDiff, currentDiff;
	if (ar.length) {
		closest = ar[0];
		for (i; i < ar.length; i++) {
			closestDiff = Math.abs(num - closest);
			currentDiff = Math.abs(num - ar[i]);
			if (currentDiff < closestDiff) {
				closest = ar[i];
			}
			closestDiff = null;
			currentDiff = null;
		}
      
		//returns first element that is closest to number
		return closest;
	}
	//no length
	return false;
}
/*** End ***/

/*** Get Array Index Value ***/  
function get_index(value, array) {
	var pos = 0
	for (i = 0; i < array.length; i++) {
		if (array[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}
/*** End ***/

/*** Sort By Dropdown Open Close ***/
function sortByOpen() {
  if(jQuery('.tps-sort-dropdown-menu').css('display') !== 'none'){		
      sortByClose();
  }else {		
      jQuery('.tps-sort-dropdown-menu').css('display', 'block');

      if(jQuery(window).width() <= 824){
        jQuery('.tps-sort-dropdown-menu').addClass('tps-sort-dropdown-menu-show');
      }
  }
}
/*** End ***/

/*** Sort By Dropdown Close OnMouseLeave ***/
function sortByClose() {
  jQuery(".tps-sort-dropdown-menu").css('display', 'none');

  if(jQuery(window).width() <= 824){
    jQuery('.tps-sort-dropdown-menu').removeClass('tps-sort-dropdown-menu-show');
  }
}
/*** End ***/

/**** Mobile Filter Open/Close Start ****/ 

function mobileFilters(action){  
  if(action == 'open'){
    $(".tps-filter-container").addClass('tps-mobile-filters');
    $('body').addClass('tps-mobile-filters-open');
  }else{
    $(".tps-filter-container").removeClass('tps-mobile-filters');
    $('body').removeClass('tps-mobile-filters-open');
  }  
}
/*** End ***/

/*** Mobile Filter Close onClick Overly Start ***/
jQuery(document).on('click','.tps-mobile-filters',function(e){
  var container = $(".tps-filter-tabs-container");
  if(!container.is(e.target) && container.has(e.target).length === 0){     
    mobileFilters('close');
  }
});

$(document).on("click", function (e) {
    if (
        $(".tps-filter-container").hasClass("tps-mobile-filters") &&
        !$(e.target).closest(".tps-filter-container").length &&
        !$(e.target).closest(".tps-mobile-filter-button").length
    ) {
        $(".tps-filter-container").removeClass("tps-mobile-filters");
        $("body").removeClass("tps-mobile-filters-open");
    }
});
/*** Mobile Filter Close onClick Overly End ***/

/**** Mobile Filter Button Sticky Start ****/ 
// $(window).scroll(function(){
//     if ($(this).scrollTop() > 500) {
//        $('.tps-mobile-filter-button-section').addClass('tps-sticky-btn');
//     } else {
//        $('.tps-mobile-filter-button-section').removeClass('tps-sticky-btn');
//     }
// });
$(window).on('scroll resize', function () {
    if ($(window).width() <= 767) {
        if ($(window).scrollTop() > 500) {
            $('.tps-mobile-filter-button-section').addClass('tps-sticky-btn');
        } else {
            $('.tps-mobile-filter-button-section').removeClass('tps-sticky-btn');
        }
    } else {
        $('.tps-mobile-filter-button-section').removeClass('tps-sticky-btn');
    }
});
/*** End ***/

/*** Create & Update Session Filters Array Start ***/
function updateSessionFilters(arrayKey, filterKey, newValues) {
    // Retrieve the filters object from local storage or initialize an empty object
    let filters = JSON.parse(localStorage.getItem(arrayKey)) || {};

    // Split the newValues string by commas to handle multiple values
    let newValuesArray = newValues.split(',').map(value => value.trim());
 
    // Replace the old values with new ones
    filters[filterKey] = newValuesArray;
 
    // Save the updated filters object back to local storage
    localStorage.setItem(arrayKey, JSON.stringify(filters));
}
/*** Create & Update Session Filters Array End ***/

/*** Refine Your Results Focus To Filter Section ***/
function refineYourResults(){
  var target = '.tps-filter-container'; 
  $('html, body').animate({
        scrollTop: $(target).offset().top - 250
  }, 'slow'); 
}
/*** End ***/

/*** Get Daimond ID From Url Start ***/
function getURLParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}    
/*** End ***/

/*** Product Detail Info Open Close (independent toggle per section) ***/
$(document).on("click", ".tps-product-detail-section-heading", function() {
  var data_section = jQuery(this).attr("data-section");
  var $current = jQuery(this);
  var $panel = jQuery('.tps-product-details-' + data_section);

  if ($current.hasClass('active')) {
    // this section is open -> close only this one
    $current.removeClass('active');
    $current.find('span').removeClass('tps-arrow-up').addClass('tps-arrow-down');
    $panel.stop(true, true).slideUp('slow');

  } else {
    // this section is closed -> open only this one
    $current.addClass('active');
    $current.find('span').addClass('tps-arrow-up').removeClass('tps-arrow-down');
    $panel.stop(true, true).slideDown('slow');
  }
});
/*** End ***/

/*** Vertical Thumbnail Gallery Slick Slider Start ***/
// function settingGalleryThumbnailSlider(verticalSlider){
//   if(jQuery(window).width() <= 900){
//     $('.tps-mobile-hide').remove();
//     $('.tps_image_desk_banner').remove();
//     var verticalSlider = false;
//   }else{
//     $('.tps-desktop-hide').remove();
//     $('.tps_image_mob_banner').remove();
//   }
//   $('.tps-main-image-slide').slick({
//        slidesToShow: 1,
//        slidesToScroll: 1,
//        infinite: true,
//        arrows: false,       
//        adaptiveHeight: true,
//        asNavFor: '.tps-thumb-image-slide',
//        draggable: false,
//        lazyLoad: 'progressive',
//        responsive 		: [
// 		  		{
// 			      	breakpoint: 992,
// 			      	settings: {
// 			        	slidesToShow 	: 1,
// 			        	slidesToScroll 	: 1,
//                         arrows          : true,
// 			        	adaptiveHeight  : true,		
//                         infinity: true,
// 			      	}
// 			    },
// 		  		{
// 			      	breakpoint: 768,
// 			      	settings: {
// 			        	slidesToShow 	: 1,
// 			        	slidesToScroll 	: 1,
//                         arrows          : true,
// 			        	adaptiveHeight  : true,	
//                         infinity: true,
// 			      	}
// 			    },
// 			    {
// 			      	breakpoint: 640,
// 			      	settings: {
// 			        	slidesToShow 	: 1,
// 			        	slidesToScroll 	: 1,
//                         arrows          : true,
// 			        	adaptiveHeight  : true,		
//                         infinity: true,
// 			      	}
// 			    },
// 			    {
// 			      	breakpoint: 581,
// 			      	settings: {
// 			        	slidesToShow 	: 1,
// 			        	slidesToScroll 	: 1,
//                         arrows          : true,
// 			        	adaptiveHeight  : true,			        	
//                         infinity: true,
// 			      	}
// 			    },
// 		 	], 
//    });

//   if(verticalSlider == true){
//      console.log("vetical slider ")
//     $('.tps-thumb-image-slide').slick({
//          vertical: true,
//          verticalSwiping: true,
//          slidesToShow: 4,
//          slidesToScroll: 1,
//          infinite: true,
//          asNavFor: '.tps-main-image-slide',        
//          focusOnSelect: true,
//          draggable: false, 
//          arrows: true,
//          lazyLoad: 'progressive',
//      });
//   }else{
//     console.log("vetical slider 1")
//     $('.tps-thumb-image-slide').slick({
//        vertical: verticalSlider,
//        verticalSwiping: true,
//        slidesToShow: 5,
//        slidesToScroll: 1,
//        infinite: true,
//        asNavFor: '.tps-main-image-slide',        
//        focusOnSelect: true,
//        draggable: false, 
//        arrows: true,
//        lazyLoad: 'progressive',
//        responsive 		: [
// 		  		{
// 			      	breakpoint: 992,
// 			      	settings: {
// 			        	slidesToShow 	: 4,
// 			        	slidesToScroll 	: 1,
//                         arrows          : false,
// 			        	adaptiveHeight  : true,		
//                         infinity: true,
// 			      	}
// 			    },
// 		  		{
// 			      	breakpoint: 768,
// 			      	settings: {
// 			        	slidesToShow 	: 4,
// 			        	slidesToScroll 	: 1,
//                         arrows          : false,
// 			        	adaptiveHeight  : true,	
//                         infinity: true,
// 			      	}
// 			    },
// 			    {
// 			      	breakpoint: 640,
// 			      	settings: {
// 			        	slidesToShow 	: 4,
// 			        	slidesToScroll 	: 1,
//                         arrows          : false,
// 			        	adaptiveHeight  : true,	
//                         infinity: true,
// 			      	}
// 			    },
// 			    {
// 			      	breakpoint: 581,
// 			      	settings: {
// 			        	slidesToShow 	: 4,
// 			        	slidesToScroll 	: 1,
//                         arrows          : false,
// 			        	adaptiveHeight  : true,	
//                         infinity: true,
// 			      	}
// 			    },
// 		 	], 
//     });
//   }
// }
/*** Vertical Thumbnail Gallery Slick Slider End ***/

/*** Vertical Thumbnail Gallery Slick Slider Start ***/
function settingGalleryThumbnailSlider(verticalSlider){
  var isMobileScrollbar = jQuery(window).width() <= 767;

  if(jQuery(window).width() <= 900){
    $('.tps-mobile-hide').remove();
    $('.tps_image_desk_banner').remove();
    var verticalSlider = false;
  }else{
    $('.tps-desktop-hide').remove();
    $('.tps_image_mob_banner').remove();
  }

  var $mainSlide = $('.tps-main-image-slide');

  if(isMobileScrollbar){
    $mainSlide.on('afterChange', function(event, slick, currentSlide){
      tpsUpdateSwiperScrollbar(currentSlide, slick.slideCount);
    });
  }

  $mainSlide.slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       infinite: true,
       arrows: false,       
       adaptiveHeight: true,
       asNavFor: isMobileScrollbar ? null : '.tps-thumb-image-slide',
       draggable: false,
       lazyLoad: 'progressive',
       responsive 		: [
		  		{
			      	breakpoint: 992,
			      	settings: {
			        	slidesToShow 	: 1,
			        	slidesToScroll 	: 1,
                        arrows          : true,
			        	adaptiveHeight  : true,		
                        infinity: true,
			      	}
			    },
		  		{
			      	breakpoint: 768,
			      	settings: {
			        	slidesToShow 	: 1,
			        	slidesToScroll 	: 1,
                        arrows          : true,
			        	adaptiveHeight  : true,	
                        infinity: true,
			      	}
			    },
			    {
			      	breakpoint: 640,
			      	settings: {
			        	slidesToShow 	: 1,
			        	slidesToScroll 	: 1,
                        arrows          : true,
			        	adaptiveHeight  : true,		
                        infinity: true,
			      	}
			    },
			    {
			      	breakpoint: 581,
			      	settings: {
			        	slidesToShow 	: 1,
			        	slidesToScroll 	: 1,
                        arrows          : true,
			        	adaptiveHeight  : true,			        	
                        infinity: true,
			      	}
			    },
		 	], 
   });

  // On mobile, replace the thumbnail strip with a Swiper-style scrollbar instead of initializing it as a nav slider.
  if(isMobileScrollbar){
    $('.tps-thumb-image-slide').hide();
    tpsInitSwiperScrollbar($mainSlide);
    return;
  }

  if(verticalSlider == true){
    $('.tps-thumb-image-slide').slick({
         vertical: true,
         verticalSwiping: true,
         slidesToShow: 4,
         slidesToScroll: 1,
         infinite: true,
         asNavFor: '.tps-main-image-slide',        
         focusOnSelect: true,
         draggable: false, 
         arrows: true,
         lazyLoad: 'progressive',
     });
  }else{
    $('.tps-thumb-image-slide').slick({
       vertical: verticalSlider,
       verticalSwiping: true,
       slidesToShow: 5,
       slidesToScroll: 1,
       infinite: true,
       asNavFor: '.tps-main-image-slide',        
       focusOnSelect: true,
       draggable: false, 
       arrows: true,
       lazyLoad: 'progressive',
       responsive 		: [
		  		{
			      	breakpoint: 992,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,		
                        infinity: true,
			      	}
			    },
		  		{
			      	breakpoint: 768,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,	
                        infinity: true,
			      	}
			    },
			    {
			      	breakpoint: 640,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,	
                        infinity: true,
			      	}
			    },
			    {
			      	breakpoint: 581,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,	
                        infinity: true,
			      	}
			    },
		 	], 
    });
  }
}
/*** Vertical Thumbnail Gallery Slick Slider End ***/
/*** Mobile Gallery Swiper-Style Scrollbar Start ***/
function tpsInjectSwiperScrollbarStyles(){
  if(document.getElementById('tps-swiper-scrollbar-style')) return;

  var css = '' +
    '.tps-swiper-scrollbar{position:relative;height:4px;width:100%;margin:12px auto 0;background:rgba(0,0,0,0.12);border-radius:2px;overflow:hidden;}' +
    '.tps-swiper-scrollbar-drag{position:absolute;top:0;left:0;height:100%;background:#000;border-radius:2px;transition:left 0.2s ease;}';

  var $style = $('<style id="tps-swiper-scrollbar-style">' + css + '</style>');
  $('head').append($style);
}

function tpsInitSwiperScrollbar($mainSlide){
  tpsInjectSwiperScrollbarStyles();

  if(!$mainSlide || !$mainSlide.length){
    $mainSlide = $('.tps-main-image-slide');
  }

  // Avoid stacking duplicate scrollbars if this gets called more than once.
  $mainSlide.siblings('.tps-swiper-scrollbar').remove();

  var totalSlides = $mainSlide.find('.tps-main-slide').length;
  if(totalSlides <= 1) return; // nothing to scroll through

  var $scrollbar = $('<div class="tps-swiper-scrollbar"><div class="tps-swiper-scrollbar-drag"></div></div>');
  $mainSlide.after($scrollbar);

  tpsUpdateSwiperScrollbar(0, totalSlides);

  var isDragging = false;

  function seekToPosition(e){
    var touch = (e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length) ? e.originalEvent.touches[0] : e;
    var offsetLeft = $scrollbar.offset().left;
    var width = $scrollbar.outerWidth();
    var x = touch.pageX - offsetLeft;
    var ratio = Math.min(Math.max(x / width, 0), 1);
    var targetSlide = Math.round(ratio * (totalSlides - 1));
    $mainSlide.slick('slickGoTo', targetSlide);
  }

  $scrollbar.off('mousedown.tpsScrollbar touchstart.tpsScrollbar').on('mousedown.tpsScrollbar touchstart.tpsScrollbar', function(e){
    isDragging = true;
    seekToPosition(e);
  });

  $(document).off('mousemove.tpsScrollbar touchmove.tpsScrollbar').on('mousemove.tpsScrollbar touchmove.tpsScrollbar', function(e){
    if(!isDragging) return;
    seekToPosition(e);
  });

  $(document).off('mouseup.tpsScrollbar touchend.tpsScrollbar').on('mouseup.tpsScrollbar touchend.tpsScrollbar', function(){
    isDragging = false;
  });
}

function tpsUpdateSwiperScrollbar(currentSlide, totalSlides){
  var $drag = $('.tps-swiper-scrollbar-drag');
  if(!$drag.length || !totalSlides) return;

  var dragWidthPercent = Math.max(100 / totalSlides, 15); // keep the drag handle reasonably visible
  var maxOffsetPercent = 100 - dragWidthPercent;
  var offsetPercent = totalSlides > 1 ? (currentSlide / (totalSlides - 1)) * maxOffsetPercent : 0;

  $drag.css({
    'width': dragWidthPercent + '%',
    'left': offsetPercent + '%'
  });
}
/*** Mobile Gallery Swiper-Style Scrollbar End ***/

/*** Get Formatted Metal Value For Image Alt Text Start ***/  
function getFromatedMetalValue(setting_metal){
  if(setting_metal.indexOf("18K ") >= 0){ 
     metal = setting_metal.replace('18K ','').trim();                 
  }else if(setting_metal.indexOf("14K ") >= 0){ 
     metal = setting_metal.replace('14K ','').trim();         
  }else{ 
     metal = setting_metal;
  }  
  return metal;
}
/*** Get Formatted Metal Value For Image Alt Text End ***/ 

/*** Get Final Ring Product Price Start ***/
function getFinalProductPrice(){
  var currency_rate = Shopify.currency.rate;
  
  var setting_info = JSON.parse(localStorage.getItem("ring-selected-setting"));  
  var diamond_info = JSON.parse(localStorage.getItem("ring-selected-diamond"));

  var setting_price = setting_info[0].setting_price;
  var diamond_price = diamond_info[0].diamond_price;
 
  var final_price = parseInt(setting_price)+parseInt(diamond_price);
  var final_converted_price = final_price * currency_rate;
    
  // final_price = getPriceWithCurrencySymbol(final_price);
  final_price = Shopify.formatMoney(final_converted_price * 100, theme.moneyFormat);
  return final_price;
}
function getFinalCompProductPrice(){
  var currency_rate = Shopify.currency.rate;
  
  var setting_info = JSON.parse(localStorage.getItem("ring-selected-setting"));  
  var diamond_info = JSON.parse(localStorage.getItem("ring-selected-diamond"));

  var setting_price = setting_info[0].setting_comp_price;
  var diamond_price = diamond_info[0].diamond_comprice;
 console.log('setting_price',setting_price);
 console.log('diamond_price',diamond_price);
  var final_price = parseInt(setting_price)+parseInt(diamond_price);
  console.log('final_price',final_price);
  var final_converted_price = final_price * currency_rate;
    
  // final_price = getPriceWithCurrencySymbol(final_price);
  final_price = Shopify.formatMoney(final_converted_price * 100, theme.moneyFormat);
  return final_price;
}

function getFinalSavingProductPrice(){
  var currency_rate = Shopify.currency.rate;
  
  var setting_info = JSON.parse(localStorage.getItem("ring-selected-setting"));  
  var diamond_info = JSON.parse(localStorage.getItem("ring-selected-diamond"));

  var setting_price = setting_info[0].setting_price;
  var diamond_price = diamond_info[0].diamond_price;

  var setting_comprice = setting_info[0].setting_comp_price;
  var diamond_comprice = diamond_info[0].diamond_comprice;
 
  var final_price1 = parseInt(setting_price)+ parseInt(diamond_price);
  var final_price2 = parseInt(setting_comprice)+ parseInt(diamond_comprice);
  var final_price = final_price2 - final_price1;
  var final_converted_price = final_price * currency_rate;
    
  // final_price = getPriceWithCurrencySymbol(final_price);
  final_price = Shopify.formatMoney(final_converted_price * 100, theme.moneyFormat);
  return final_price;
}

function getPriceWithCurrencySymbol(price){
  price = Shopify.formatMoney(price*100,theme.moneyFormat);
  return price;
}
/*** Get Final Ring Product Price End ***/

/*** Show Product Detail & Final Ring Page Loader Start ***/
function showProductLoader(galleryStyle){
  if(galleryStyle == 'grid-view'){            
    if(jQuery(window).width() <= 767){
      jQuery(".tps-loader-horizontal-thumb-slider").show();
    }else{
      jQuery(".tps-loader-"+galleryStyle).show();
    }
  }else{
    jQuery(".tps-loader-"+galleryStyle).show();
  }
}
/*** Show Product Detail & Final Ring Page Loader End ***/

/*** Mobile Step Icon Click Info Popup Start ***/
$(document).on("click", ".tps-step-content", function(){
  // if(jQuery(window).width() <= 991){    
    var data_step = jQuery(this).attr("data-step");
      
    jQuery('.tps-step-product-info').removeClass('tps-step-product-info-show');
    jQuery('.tps-'+data_step+'-step-product-info').addClass('tps-step-product-info-show');
  // } 
});
/*** Mobile Step Icon Click Info Popup End ***/

/*** Product Info Popoup Close Outer Click Start ***/
jQuery(document).on('click','#MainContent',function(e){
  var container = $(".tps-step-product-info");
  var container2 = $(".tps-step-content");
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0){     
    jQuery(".tps-step-product-info").removeClass('tps-step-product-info-show');
  }
});
/*** Product Info Popoup Close Outer Click End ***/

/*** Check Devise Has Camera Or Not Start ***/
// function checkCameraAvailability(){
//   var availability = "No camera detected";
//   navigator.mediaDevices?.enumerateDevices().then(devices => {
//     const hasCamera = devices.some(device => device.kind === 'videoinput');
//     if (hasCamera) {
//       availability = "Camera available";      
//     } else {
//       availability = "No camera detected";
//       jQuery(".tps-ring-try-on-section").hide();
//     }
//   }).catch(err => {
//     alert("Camera check failed:", err);
//   });
//   return availability;
// }
/*** Check Devise Has Camera Or Not End ***/

/*******
End
********/
/*** Setting Style mobile slider start ***/
function styleSlider() {
    if (typeof $.fn.slick === 'undefined') {
        console.warn('Slick Carousel not loaded yet — skipping styleSlider()');
        return;
    }
    if (!$('.tps-stylefilter-mobile-slider,.tps-shapefilter-mobile-slider').hasClass('slick-initialized')) {
        $('.tps-stylefilter-mobile-slider,.tps-shapefilter-mobile-slider').slick({
            mobileFirst: true,
            touchThreshold: 100,
            swipeToSlide: true,
            centerMode: true,
            infinite: true,
            centerPadding: '20px',
            slidesToShow: 1,
            arrows: false,
            responsive: [
                { breakpoint: 480, settings: { slidesToShow: 3 } },
                { breakpoint: 767, settings: 'unslick' }
            ]
        });
    }
}

$(window).on('load', function () {
  if(jQuery(window).width() <= 767){
    styleSlider();
  }
});
/*** Setting Style mobile slider End ***/

/*** Diamonds Meta Information Layout Start ***/
function getDiamondMetaInformation(diamondData) {
  var metaInfo = '';

    if(diamondData.caratWeight != ''){
      metaInfo += '<div class="tps-meta-data-item-wrapper">';      
      metaInfo += '<span class="tps-meta-data-item">'+diamondData.caratWeight+'</span>';
      metaInfo += '<span class="tps-meta-data-item-title">Carat</span>';
      metaInfo += '</div>';
    }
    if(diamondData.color != ''){
      metaInfo += '<div class="tps-meta-data-item-wrapper">';      
      metaInfo += '<span class="tps-meta-data-item">'+diamondData.color+'</span>';
      metaInfo += '<span class="tps-meta-data-item-title">Color</span>';
      metaInfo += '</div>';
    }else{
      metaInfo += '<div class="tps-meta-data-item-wrapper">';            
      metaInfo += '<span class="tps-meta-data-item">'+diamondData.fancyColor+'</span>';
      metaInfo += '<span class="tps-meta-data-item-title">Fancy Color</span>';
      metaInfo += '</div>';
    }    
    if(diamondData.clarity != '' && diamondData.clarity != 'NA'){
      metaInfo += '<div class="tps-meta-data-item-wrapper">';      
      metaInfo += '<span class="tps-meta-data-item">'+diamondData.clarity+'</span>';
      metaInfo += '<span class="tps-meta-data-item-title">Clarity</span>';
      metaInfo += '</div>';
    }
    if(diamondData.cut != '' && diamondData.cut != 'NA'){
      metaInfo += '<div class="tps-meta-data-item-wrapper">';         
      metaInfo += '<span class="tps-meta-data-item">'+diamondData.cut+'</span>';
      metaInfo += '<span class="tps-meta-data-item-title">Cut</span>';
      metaInfo += '</div>';
    }     
    // if(diamondData.polish != '' && diamondData.polish != 'NA'){
    //   metaInfo += '<div class="tps-meta-data-item-wrapper">'
    //   metaInfo += '<span class="tps-meta-data-item-title">Polish</span>';
    //    metaInfo += '<span class="tps-meta-data-item">'+diamondData.polish+'</span>';
    //   metaInfo += '</div>';
    // }  
  
  return metaInfo;
}
/*** End ***/

